import React from 'react';
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { Provider } from 'react-redux';
import { Store } from '../../redux/stores';
import { ThemeProvider } from 'styled-components';

import Home from '../Home/Home';
import Login from '../Login/Login';
import Table from '../Table/Table';
import StreamLink from '../StreamLink/StreamLink';
import TemplateBuilder from '../TemplateBuilder/TemplateBuilder';
import Loading from '../Loading/Loading';
import Connector from '../Connector/Connector2';
import ErrorHandler from '../ErrorHandler/ErrorHandler';
import ErrorShow from '../ErrorHandler/ErrorShow';
import ErrorBoundary from '../ErrorHandler/ErrorBoundary';
import TableList from '../Home/TablesList/TablesList';
import TemplatesList from '../Home/TemplatesList/TemplatesList';
import Friends from '../Home/Friends/Friends';
import UserProfile from '../Home/UserProfile/UserProfile';
import Messages from '../Home/Messages/Messages';
import FindTables from '../Home/FindTables/FindTables';
import TableDetail from '../Home/TableDetail/TableDetail';
import TableForm from '../Home/TableForm/TableForm';
import ProfileForm from '../Home/ProfileForm/ProfileForm';

const theme = {
    colors: {
        main: "#F5802E",
        error: "#F00",
        confirm: "#0C0",
        cancel: "#F44",
    }
  };
  

const App = () => {
    return <div id='app-container'>
        <Provider store={Store}>
            <ErrorBoundary id="global">
                <BrowserRouter basename={'/app'}>
                    <ThemeProvider theme={theme}>
                        <div id='app-content'>
                            <Switch>
                                <Route path="/home">
                                    <Home>
                                        <Switch>
                                            <Route path="/home" exact><TableList /></Route>
                                            <Route path="/home/templates" exact><TemplatesList /></Route>
                                            <Route path="/home/friends" exact><Friends /></Route>
                                            <Route path="/home/user/:id"><UserProfile /></Route>
                                            <Route path="/home/me"><ProfileForm /></Route>
                                            <Route path="/home/messages"><Messages /></Route>
                                            <Route path="/home/table/new"><TableForm /></Route>
                                            <Route path="/home/table/:id"><TableDetail /></Route>
                                            <Route path="/home/tables"><FindTables /></Route>
                                        </Switch>
                                    </Home>
                                </Route>
                                <Route path="/table/:id"><Table /></Route>
                                <Route path="/stream/:id"><StreamLink /></Route>
                                <Route path="/templatebuilder/:templateId"><TemplateBuilder /></Route>
                                <Route path="/templatebuilder"><TemplateBuilder /></Route>
                                <Route path="/"><Login /></Route>
                            </Switch>
                        <Connector />
                        </div>
                    </ThemeProvider>
                </BrowserRouter>
                <ErrorHandler />
                <ErrorShow />
                <Loading />
            </ErrorBoundary>
        </Provider>
    </div>
}

export default App;